<template>
  <div v-if="legalComponent" class="legal-template py-16">
    <div class="max-w-7xl mx-auto px-4">
      <Crumbs :crumbs="crumbs" class="mb-8" />
      <component :is="legalComponent" class="legal-component"></component>
    </div>
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  useMeta,
  useRoute,
} from '@nuxtjs/composition-api';
import Hipaa from './Hipaa.vue';
import Privacy from '@/modules/InformationPages/Legal/components/Privacy/Privacy.vue';
import PreviousPrivacy from '@/modules/InformationPages/Legal/components/Privacy/PreviousPrivacy/PreviousPrivacy.vue';
import Retention from './Retention.vue';
import TOS from '@/modules/InformationPages/Legal/components/TOS/TOS.vue';
import TOSPrevious from '@/modules/InformationPages/Legal/components/TOS/PreviousTOS/TOSPrevious.vue';
import Cookie from '@/modules/CookiePolicy/pages/CookiePolicy.vue';
import Payroll from '@/modules/InformationPages/Legal/components/Payroll/Payroll.vue';
import Crumbs from '@/components/Crumbs';
import useGlobalSettings from '@/hooks/useGlobalSettings';
import { RouteBase, Slugs } from '@/modules/InformationPages/Legal/constants/Routes'


export default defineComponent({
  name: 'LegalTemplate',
  components: { Crumbs },
  setup() {
    const route = useRoute();
    const slug = computed(() => route.value.params?.slug || '');
    const defaultHeader = computed(() => slug.value.charAt(0).toUpperCase() + slug.value.slice(1));



    const legalComponent = computed(
      () => {
        const componentStr = slug.value;
        switch (componentStr) {
          case Slugs.TOS:
            return TOS  
          case Slugs.TOS_PREVIOUS:
            return TOSPrevious
          case Slugs.HIPAA:
            return Hipaa
          case Slugs.PRIVACY:
            return Privacy
          case Slugs.PRIVACY_PREVIOUS:
            return PreviousPrivacy
          case Slugs.DATA_RETENTION:
            return Retention
          case Slugs.COOKIE:
            return Cookie
          case Slugs.PAYROLL:
            return Payroll 
        }
      }
    );

    const { setHeader, getHeader } = useGlobalSettings();

    setHeader({
      header: defaultHeader.value,
      subheader: null,
      heroImage: null,
      metaTitle: defaultHeader.value,
      registration: false,
      noHero: false,
    });

    const crumbs = computed(()=>[
      {
        label: 'Legal',
        to: `/${RouteBase}`,
      },
      {
        label: getHeader.header || slug.value.toUpperCase() + ' ' + 'Policy',
        to: `/${RouteBase}/${slug.value}`,
      },
    ]);


    return {
      crumbs,
      legalComponent,
    };
  },
});
</script>
